module.exports = __webpack_public_path__ + "fe83fb26e6ba15058a9d5999b94e1bd7.png";